{
  "actions.activate": "Aktivieren",
  "actions.add": "Hinzufügen",
  "actions.add_deadline": "Frist hinzufügen",
  "actions.addresses": "Adressen",
  "actions.ai_translation": "AI Übersetzungen",
  "actions.apply": "Übernehmen",
  "actions.cancel": "Abbrechen",
  "actions.continue": "Fortfahren",
  "actions.copy_email": "E-Mail kopieren",
  "actions.copy_link": "Link kopieren",
  "actions.create": "Erstellen",
  "actions.create_box": "Box erstellen",
  "actions.create_file": "Datei erstellen",
  "actions.deactivate": "Deaktivieren",
  "actions.delete": "Löschen",
  "actions.disabled": "deaktiviert",
  "actions.download": "Herunterladen",
  "actions.duplicate": "Duplizieren",
  "actions.edit": "Bearbeiten",
  "actions.edit_deadline": "Frist bearbeiten",
  "actions.folder": "Neuer Ordner",
  "actions.install_app": "DeepBox App installieren",
  "actions.language": "Sprache",
  "actions.load_more": "Mehr laden...",
  "actions.login": "Anmeldung",
  "actions.logout": "Abmelden",
  "actions.manage": "Verwalten",
  "actions.manage_your_account": "Konto verwalten",
  "actions.more": "Mehr...",
  "actions.more_boxes": "Mehr Boxen...",
  "actions.move": "Verschieben",
  "actions.move_to": "Zu {nodeName} bewegen ",
  "actions.new": "Neu",
  "actions.new_entry": "Neuer Eintrag",
  "actions.no": "Nein",
  "actions.ok": "Ok",
  "actions.open_details": "Details öffnen",
  "actions.open_service": "{service} öffnen",
  "actions.preview": "Vorschau",
  "actions.refresh": "Aktualisieren",
  "actions.remove": "Entfernen",
  "actions.rename": "Umbenennen",
  "actions.reset": "Zurücksetzen",
  "actions.reset_search": "Suche zurücksetzen",
  "actions.save": "Speichern",
  "actions.select": "Wählen",
  "actions.try_again": "Erneut versuchen",
  "actions.upload": "Hochladen",
  "actions.upload_file": "Dateien hochladen",
  "actions.upload_folder": "Ordner hochladen",
  "actions.view": "Ansicht",
  "actions.yes": "Ja",
  "admin.navigation.account": "KONTO",
  "admin.navigation.account_profile": "Dein Profil",
  "admin.navigation.organization": "Organisation",
  "admin.navigation.organization_boxes": "Boxen",
  "admin.navigation.organization_boxes_tags": "Tags",
  "admin.navigation.organization_groups": "Gruppen",
  "admin.navigation.organization_personal": "Persönliche Daten",
  "admin.navigation.organization_subheader": "ORGANISATION",
  "admin.navigation.organization_subscription": "Abonnement",
  "admin.navigation.organization_users": "Benutzer",
  "admin.navigation.organization_verification_in_progress": "Verifikation",
  "alerts.aba_ninja.continue_process": "Diese Box ist mit DeepNinja verknüpft",
  "alerts.box.only_advanced_box_selectable": "Es darf nur eine Box vom Typ \"Advanced\" ausgewählt werden.",
  "alerts.company_accounting.open_invoices.action": "Zu den Rechnungen",
  "alerts.company_accounting.open_invoices.label": "Zahlung ausstehend",
  "alerts.company_accounting.open_invoices.member.content": "Für Ihre Organisation liegt mindestens eine unbezahlte Rechnung vor. Bitte informieren Sie den Owner der Organisation, da unbezahlte Rechnungen zu einer Deaktivierung der Organisation führen können.",
  "alerts.company_accounting.open_invoices.owner.content": "Es liegt mindestens eine unbezahlte Rechnung vor. Bitte begleichen Sie diese, um eine Deaktivierung Ihrer Organisation zu vermeiden.",
  "alerts.company_accounting.overusing.action": "Bitte prüfen Sie Ihr Abonnement.",
  "alerts.company_accounting.overusing.label": "Kapazität übernutzt",
  "alerts.company_accounting.overusing.member.content": "Für die Organisation wird derzeit mehr Kapazität genutzt, als im Abonnement verfügbar ist. Eine Überschreitung der Kapazität kann dazu führen, dass die Organisation deaktiviert wird. Bitte informieren Sie den Owner der Organisation.",
  "alerts.company_accounting.overusing.owner.content": "Ihre Organisation nutzt derzeit mehr Kapazität, als im Abonnement enthalten ist. Bitte erweitern Sie Ihr Abonnement oder reduzieren Sie die Nutzung, um eine Deaktivierung der Organisation zu vermeiden.",
  "alerts.company_verification.action": "Fortfahren",
  "alerts.company_verification.content": "Der Verifizierungsprozess läuft. Sie können die erste Box anlegen, sobald die Verifizierung abgeschlossen ist.",
  "alerts.company_verification.title": "Verifikation",
  "alerts.hoop.continue_process": "Diese Box ist mit Hoop verknüpft. Bei Hoop können Sie jederzeit den Stand der Gründung/Änderung Ihres Unternehmens überprüfen.",
  "alerts.portal.continue_process": "Diese Box ist mit DeepPortal verknüpft",
  "api.deepbox.errors.node.move.out-of-box.prohibited.generic-folder": "Generischer Ordner kann nicht in eine andere Box verschoben werden. | {n} generische Ordner können nicht in eine andere Box verschoben werden..",
  "api.deepbox.errors.node.move.out-of-box.prohibited.shared-folder": "Geteilter Ordner kann nicht in eine andere Box verschoben werden. | {n} geteilte Ordner können nicht in eine andere Box verschoben werden.",
  "api.deepbox.errors.node.move.recursive": "Ein übergeordneter Ordner kann nicht in einen untergeordneten Ordner verschoben werden. | {n} übergeordnete Ordner können nicht in einen untergeordneten Ordner verschoben werden.",
  "apps.subtitle.deepbox": "Sicheres Speichern und Teilen von Dokumenten",
  "apps.subtitle.deepsign": "Rechtskonforme, elektronische Signaturen",
  "base.date_picker.example_date": "Bsp.: {example}",
  "base.date_picker.modal_btn_cancel": "Abbrechen",
  "base.date_picker.modal_btn_save": "Übernhemen",
  "box.boxes_switch": "Boxes",
  "box.n_selected_detail": "1 ausgewählt ({detail}) | {n} ausgewählt ({detail})",
  "box.policies.can_not_access_inbox_and_files.text": "Sie haben keine Berechtigung, Dateien an den ausgewählten Ort zu verschieben.",
  "box.private.generics.deepmail.error.logged_in_wrong_account.message": "Sie sind derzeit mit dem Benutzer <b>{userEmail}</b> angemeldet. <br />Die verschlüsselte Nachricht wurde an die E-Mail-Adresse <b>{queryEmail}</b> gesendet. Sie müssen sich mit dieser E-Mail-Adresse anmelden.",
  "box.private.generics.deepmail.error.logged_in_wrong_account.title": "Sie sind mit dem falschen Konto angemeldet",
  "box.private.generics.deepmail.title": "DeepMail",
  "box.private.generics.deepsign.banner.content": "In der DeepSign Ablage finden Sie alle abgeschlossenen Dokumente. Für ausstehende oder neue Signaturprozesse wechseln Sie in die {link}",
  "box.private.generics.deepsign.banner.link": "DeepSign-Applikation",
  "box.private.generics.deepsign.title": "DeepSign Ablage",
  "box.types.advanced": "Advanced Box",
  "box.types.advanced_per_use": "Advanced Box mit Fixpreis",
  "box.types.portal": "Portal",
  "box.types.simple": "Simple Box",
  "box_details.access.error.forbidden": "Der Ordner existiert nicht oder Sie haben keine Berechtigung, auf diesen Ordner zuzugreifen.",
  "box_details.archive.banner.subtitle": "Nachweisbare Integrität",
  "box_details.archive.banner.text": "Unveränderbar · Aufbewahrung 10 Jahre ab Eingang · Qualifizierter Zeitstempel nach ZertES",
  "box_details.all_files_reviewed": "Alle Dateien wurden überprüft.",
  "box_details.details_drawer.amount": "Betrag",
  "box_details.details_drawer.attributes": "Attribute",
  "box_details.details_drawer.category": "Kategorie",
  "box_details.details_drawer.comments": "Kommentare",
  "box_details.details_drawer.created": "Erstellt",
  "box_details.details_drawer.details": "Details",
  "box_details.details_drawer.details_file": "Dateidetails",
  "box_details.details_drawer.details_folder": "Ordnerdetails",
  "box_details.details_drawer.file": "Datei",
  "box_details.details_drawer.files": "Dokumente",
  "box_details.details_drawer.folder": "Verzeichnis",
  "box_details.details_drawer.location": "Standort",
  "box_details.details_drawer.me": "Ich",
  "box_details.details_drawer.modified": "Geändert",
  "box_details.details_drawer.opened": "Geöffnet",
  "box_details.details_drawer.owner": "Eigentümer",
  "box_details.details_drawer.path": "Pfad",
  "box_details.details_drawer.queue": "Inbox",
  "box_details.details_drawer.sections.comments.counter": "Kommentar | Kommentare",
  "box_details.details_drawer.sections.comments.text_add": "Kommentar hinzufügen",
  "box_details.details_drawer.sections.deep_validator.actions.processing": "Bearbeiten...",
  "box_details.details_drawer.sections.deep_validator.actions.re_validate": "Re-validieren",
  "box_details.details_drawer.sections.deep_validator.actions.validate": "Validieren",
  "box_details.details_drawer.sections.deep_validator.jurisdiction": "Rechtsraum",
  "box_details.details_drawer.sections.deep_validator.jurisdictions.Unknown": "Unbekannter Rechtsraum",
  "box_details.details_drawer.sections.deep_validator.jurisdictions.ZertES": "ZertES",
  "box_details.details_drawer.sections.deep_validator.jurisdictions.eIDAS": "eIDAS",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.indeterminate": "1 unbestimmte Signatur | {n} unbestimmte Signaturen",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.invalid": "1 ungültige Signatur | {n} ungültige Signaturen",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.unsupported": "1 nicht unterstützte Signatur | {n} nicht unterstützte Signaturen",
  "box_details.details_drawer.sections.deep_validator.n_signature_status.valid": "1 gültige Signatur | {n} gültige Signaturen",
  "box_details.details_drawer.sections.deep_validator.no_signatures_found": "Keine Unterschriften gefunden.",
  "box_details.details_drawer.sections.deep_validator.nr_of_signatures": "Anzahl Signaturen",
  "box_details.details_drawer.sections.deep_validator.signature_type": "Signaturart",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_QESeal": "Qualifiziertes elektronisches Siegel",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_QESig": "Qualifizierte elektronische Signatur",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_RegESeal": "Geregeltes elektronisches Siegel",
  "box_details.details_drawer.sections.deep_validator.signature_types.CH_RegESig": "Geregelte elektronische Signatur",
  "box_details.details_drawer.sections.deep_validator.signature_types.Indeterminate_QESeal": "Qualifiziertes elektronisches Siegel (unbestimmt)",
  "box_details.details_drawer.sections.deep_validator.signature_types.Indeterminate_QESig": "Qualifizierte elektronische Signatur (unbestimmt)",
  "box_details.details_drawer.sections.deep_validator.signature_types.Indeterminate_Unknown": "Unbestimmte elektronische Signatur",
  "box_details.details_drawer.sections.deep_validator.signature_types.Not_AdES": "Ungültige elektronische Signatur",
  "box_details.details_drawer.sections.deep_validator.signature_types.Not_AdES_but_QC": "Qualifizierte elektronische Signatur (ungültig)",
  "box_details.details_drawer.sections.deep_validator.signature_types.Not_AdES_but_QC_with_QSCD": "Qualifizierte elektronische Signatur (ungültig)",
  "box_details.details_drawer.sections.deep_validator.signature_types.QESeal": "Qualifiziertes elektronisches Siegel",
  "box_details.details_drawer.sections.deep_validator.signature_types.QESig": "Qualifizierte elektronische Signatur",
  "box_details.details_drawer.sections.deep_validator.signature_types.Unknown": "Unbekannte Signaturart",
  "box_details.details_drawer.sections.deep_validator.time_of_signature": "Zeitpunkt der Signatur",
  "box_details.details_drawer.sections.deep_validator.validation_result_indication": "Resultat Signaturprüfung",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.FAILED": "Signature ist ungültig",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.INDETERMINATE": "Signature ist unbestimmt",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.NO_SIGNATURE_FOUND": "Keine Signatur gefunden",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.PASSED": "Signatur ist gültig",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.TOTAL_FAILED": "Signature ist ungültig",
  "box_details.details_drawer.sections.deep_validator.validation_result_indications.TOTAL_PASSED": "Signatur ist gültig",
  "box_details.details_drawer.sections.deep_validator.validation_results": "Ergebnis der Prüfung",
  "box_details.details_drawer.sections.tags.assign": "Tags hinzufügen",
  "box_details.details_drawer.sections.tags.counter": "Tag | Tags",
  "box_details.details_drawer.size": "Grösse",
  "box_details.details_drawer.tags": "Tags",
  "box_details.details_drawer.trash": "Papierkorb",
  "box_details.folder_is_empty": "Dieser Ordner ist leer.",
  "box_details.items": "1 Objekt | {n} Objekte",
  "box_details.load_more": "Nachladen",
  "box_details.more": "Mehr",
  "box_details.more_items": "+1 weitere Objekt | +{n} weitere Objekte",
  "box_details.navigation.deadlines": "Fristen",
  "box_details.navigation.files": "Dokumente",
  "box_details.navigation.hint": "TIPP: Doppelklicken um zu navigieren",
  "box_details.navigation.inbox": "Inbox",
  "box_details.navigation.info_no_sub_folder": "Dieser Ordner enthält keine Unterordner",
  "box_details.navigation.queue": "Inbox",
  "box_details.navigation.trash": "Papierkorb",
  "box_details.no_items": "Keine Objekte",
  "box_details.trash.empty": "Der Papierkorb ist leer",
  "box_details.trash.info.empty": "Elemente im Papierkorb werden nach 30 Tagen endgültig gelöscht. {link}",
  "box_details.trash.info.with_files": "Elemente im Papierkorb werden nach 30 Tagen endgültig gelöscht.",
  "buttons.back": "Zurück",
  "buttons.cancel": "Abbrechen",
  "buttons.confirm": "Bestätigen",
  "buttons.continue": "Weiter",
  "buttons.discard": "Verwerfen",
  "buttons.done": "Fertig",
  "buttons.ignore_dev_int_only": "Ignorieren [Nur DEV/INT]",
  "buttons.login": "Anmelden",
  "buttons.login_now": "Jetzt anmelden",
  "buttons.proceed": "Fortfahren",
  "buttons.save": "Speichern",
  "buttons.save_and_continue": "Speichern und fortfahren",
  "buttons.save_and_verify": "Speichern und verifizieren",
  "buttons.send": "Senden",
  "buttons.start_now": "Jetzt starten",
  "buttons.to_deepbox": "Zu DeepBox",
  "buttons.upload": "Hochladen",
  "choose_your_box": "Wählen Sie Ihre Box",
  "confirmation.delete_multiple_nodes_description": "Sind Sie sicher, dass Sie diese Elemente löschen möchten? | Sind Sie sicher, dass Sie {n} Elemente löschen möchten?",
  "confirmation.delete_multiple_nodes_title": "Löschen",
  "confirmation.delete_permanently_description": "Sind Sie sicher, dass Sie {name} endgültig löschen wollen? | Sind Sie sicher, dass Sie {count} Elemente endgültig löschen möchten?",
  "confirmation.delete_permanently_title": "Dauerhaft löschen",
  "confirmation.empty_trash_description": "Sind Sie sicher, dass Sie alle Objekte im Papierkorb löschen möchten?",
  "confirmation.empty_trash_title": "Papierkorb leeren",
  "confirmation.save_open_changes.msg": "Sie haben Änderungen vorgenommen. Möchten Sie sie verwerfen oder speichern?",
  "confirmation.save_open_changes.title": "Änderungen überprüfen",
  "dashboard.private.generics.deepmail.banner.subtitle": "Ihre private Inbox für den sicheren Empfang sensibler Dateien.",
  "dashboard.private.generics.deepmail.banner.title": "DeepMail",
  "dashboard.private.generics.deepsign.banner.subtitle": "Ablage für abgeschlossene DeepSign-Dokumente",
  "dashboard.private.generics.deepsign.banner.title": "DeepSign Ablage",
  "dashboard.service.card.deepbox.btn": "DeepCloud Konto vervollständigen",
  "dashboard.service.card.deepbox.btn_manage": "Verwalten",
  "dashboard.service.card.deepbox.content": "Um DeepBox selber nutzen zu können, müssen Sie Ihr Konto vervollständigen. {link}",
  "dashboard.service.card.deepbox.create_box.btn": "Box erstellen",
  "dashboard.service.card.deepbox.create_box.content": "Erstellen Sie kostenlos Ihre erste Box, um die Schweizer All-in-One-Plattform für den sicheren Dokumentenaustausch zu nutzen.",
  "dashboard.service.card.deepbox.create_box.content_empty_boxes": "Es konnten keine Boxen gefunden werden.",
  "dashboard.service.card.deepbox.create_box.content_empty_boxes_can_not_onboard": "Sie haben die nötigen Rechte nicht, um eine Box anzulegen. <br /> \nNehmen Sie mit einen Owner oder Admin Ihrer Organisation Kontakt auf.",
  "dashboard.service.card.deepbox.onboarding_in_progress.btn": "Onboarding fortsetzen",
  "dashboard.service.card.deepbox.onboarding_in_progress.content": "Um DeepBox selber nutzen zu können, müssen Sie das Onboarding fertig durchführen. {link}",
  "dashboard.service.card.deepsign.content": "Dokumente sicher elektronisch signieren.",
  "dashboard.service.card.deepsign.no_pending_signs": "Aktuell liegen für Sie keine Dokumente zur Unterzeichnung vor.",
  "dashboard.service.card.deepsign.onboarding_in_progress.btn": "DeepSign Onboarding fortsetzen",
  "dashboard.service.card.deepsign.onboarding_in_progress.content": "Schliessen Sie das DeepSign Onboarding ab, um DeepSign auch als Initiator einsetzen zu können. {link}",
  "dashboard.service.card.deepv.btn": "DeepV verwalten",
  "dashboard.service.card.deepv.content": "Dieses Konto wurde explizit für DeepV eröffnet. Sie können DeepBox oder DeepSign ebenfalls mit diesem Konto verwenden, falls Sie dies möchten. {link}",
  "dashboard.service.card.deepv.onboarding_in_progress.btn": "DeepV Onboarding fortsetzen",
  "dashboard.service.card.deepv.onboarding_in_progress.content": "Schliessen Sie das DeepV Onboarding ab, um DeepV nutzen zu können. {link}",
  "date.added": "Hinzugefügt",
  "date.am": "AM",
  "date.days": "vor 1 Tag | vor {num} Tagen",
  "date.deleted.days": "vor 1 Tag | vor {num} Tagen",
  "date.deleted.hours": "vor 1 Stunde | vor {num} Stunden",
  "date.deleted.minutes": "vor 1 Minute | vor {num} Minuten",
  "date.deleted.months": "vor 1 Monat | vor {num} Monaten",
  "date.deleted.now": "Jetzt",
  "date.deleted.years": "vor 1 Jahr | vor {num} Jahren",
  "date.expired": "Abgelaufen",
  "date.hours": "vor 1 Stunde | vor {num} Stunden",
  "date.in_three_days": "in 3 Tagen",
  "date.in_two_days": "in 2 Tagen",
  "date.minutes": "vor 1 Minute | vor {num} Minuten",
  "date.months": "vor 1 Monat | vor {num} Monaten",
  "date.now": "Jetzt",
  "date.on": "am",
  "date.opened": "Geöffnet",
  "date.pm": "PM",
  "date.today": "Heute",
  "date.tomorrow": "Morgen",
  "date.years": "vor 1 Jahr | vor {num} Jahren",
  "date.yesterday": "Gestern",
  "deep_ui_lib.core.footer.link.help": "Hilfe",
  "deep_ui_lib.core.footer.link.impressum": "Impressum",
  "deep_ui_lib.core.footer.link.privacy_policy": "Datenschutzerklärung",
  "deep_ui_lib.core.footer.link.terms_of_service": "AGB",
  "deep_ui_lib.deep_filter_menu.all": "Alle",
  "deep_ui_lib.deep_filter_menu.clear_selected": "Auswahl löschen",
  "deep_ui_lib.deep_filter_menu.no_matching_options": "Keine passenden Optionen",
  "deep_ui_lib.deep_filter_menu.use_value": "„{value}“ verwenden",
  "deepa_chat.context_dialog_title": "Chat-Kontext ({n} Ordner) | Chat-Kontext ({n} Ordner)",
  "deepa_chat.context_filter": "Ordner filtern",
  "deepa_chat.context_label": "Kontext:",
  "deepa_chat.context_others": "+ {n} weiteres | + {n} weitere",
  "deepa_chat.empty_state": "Fragen Sie DeepA zu den Ordnern im Kontext dieses Chats.",
  "deepa_chat.export.answer": "Antwort",
  "deepa_chat.export.context": "Kontext",
  "deepa_chat.export.file_name": "Dateiname",
  "deepa_chat.export.file_name_prefix": "DeepA Chat",
  "deepa_chat.export.format": "Format",
  "deepa_chat.export.formats.docx": "Word (.docx)",
  "deepa_chat.export.formats.html": "HTML (.html)",
  "deepa_chat.export.formats.json": "JSON (.json)",
  "deepa_chat.export.formats.markdown": "Markdown (.md)",
  "deepa_chat.export.formats.pdf": "PDF (.pdf)",
  "deepa_chat.export.formats.txt": "Text (.txt)",
  "deepa_chat.export.generated_by": "Erstellt von DeepA",
  "deepa_chat.export.incomplete_answer": "Diese Antwort ist unvollständig.",
  "deepa_chat.export.leftover_file": "Die temporäre Word-Datei „{name}“ konnte nicht entfernt werden.",
  "deepa_chat.export.location": "Speichern in",
  "deepa_chat.export.no_write_permission": "Sie können in diesem Ordner keine Dateien speichern.",
  "deepa_chat.export.question": "Frage",
  "deepa_chat.export.success": "Chat als „{name}“ exportiert",
  "deepa_chat.export.title": "Chat exportieren",
  "deepa_chat.new_chat": "Neuer Chat",
  "deepa_chat.new_chat_hint": "Neuer Chat zu den ausgewählten Ordnern oder zum aktuellen Ordner, wenn kein Ordner ausgewählt ist",
  "deepa_chat.prompt_placeholder": "DeepA fragen…",
  "deepa_chat.reply_stopped": "Antwort gestoppt",
  "deepa_chat.start_chat_for": "Chat für „{name}“ starten",
  "deepa_chat.stop": "Stoppen",
  "deepa_chat.title": "DeepA Chat",
  "deepmail.error.logged_in_wrong_account.message": "Sie sind derzeit mit dem Benutzer <b>{userEmail}</b> angemeldet.<br />\nDie DeepMail wurde an die E-Mail-Adresse <b>{queryEmail}</b> gesendet.<br />\nBitte melden Sie sich mit dem richtigen Benutzer an.",
  "deepmail.error.logged_in_wrong_account.title": "Mit falschem Benutzer angemeldet",
  "deeppay.payment_order.execution_date": "Ausführungsdatum",
  "deeppay.payment_order.info_line": "Infozeile",
  "deeppay.payment_order.move_file_message": "Möchten Sie die Datei in den Ordner \"{folderName}\" verschieben?",
  "deeppay.payment_order.order_details": "Auftragsdetails",
  "deeppay.payment_order.pay_now": "Jetzt bezahlen",
  "deeppay.payment_order.payment": "Zahlung",
  "deeppay.payment_order.payment_amount": "Zahlbetrag",
  "deeppay.payment_order.payment_reference": "Zahlungsreferenz",
  "deeppay.payment_order.recipient": "Empfänger",
  "deeppay.payment_order.xml_download": "XML herunterladen",
  "deeppay.payment_order.yes_move": "Ja, verschieben",
  "deeppay.payments_history.by_address_dialog.amount": "Betrag",
  "deeppay.payments_history.by_address_dialog.created_at": "Übermittelt am",
  "deeppay.payments_history.by_address_dialog.created_by": "Übermitteld von",
  "deeppay.payments_history.by_address_dialog.destination_iban": "Empfänger IBAN",
  "deeppay.payments_history.by_address_dialog.payment_to": "Zahlungen an \"{destination}\"",
  "deeppay.payments_history.by_address_dialog.status": "Status",
  "deeppay.payments_history.card_expandable.title": "Zahlungshistorie",
  "deeppay.payments_history.list.created_by": "Übermittelt von",
  "deeppay.payments_history.list.destination": "Empfänger",
  "deeppay.payments_history.list.status.declined": "Abgelehnt",
  "deeppay.payments_history.list.status.paid": "Bezahlt",
  "deeppay.payments_history.list.status.transmitted": "Übermittelt",
  "dialogs.add": "Hinzufügen",
  "dialogs.add_deadline_title": "Frist hinzufügen",
  "dialogs.box": "Box",
  "dialogs.cancel": "Abbrechen",
  "dialogs.change": "Ändern",
  "dialogs.close": "Schliessen",
  "dialogs.create": "Erstellen",
  "dialogs.create_new_deepbox.msg": "Möchten Sie eine kostenlose Box erstellen?",
  "dialogs.create_new_deepbox.title": "Box erstellen",
  "dialogs.details": "Details",
  "dialogs.discard.btn": "Verwerfen",
  "dialogs.discard.msg": "Sind Sie sicher, dass Sie alle Änderungen verwerfen wollen?",
  "dialogs.discard.title": "Änderungen verwerfen",
  "dialogs.download_app_title": "App herunterladen",
  "dialogs.manage_tags": "Tags verwalten",
  "dialogs.member": "Mitglied",
  "dialogs.members": "Mitglieder: alle Mitglieder von ",
  "dialogs.move_items_title": "Verschiebe 1 Elemente nach... | Verschiebe {n} Elemente nach...",
  "dialogs.move_to_inbox": "In Inbox verschieben",
  "dialogs.name": "Name",
  "dialogs.newBox": "Neue Box",
  "dialogs.no": "Nein",
  "dialogs.node_create_new.error.create": "{fileName} konnte nicht erstellt werden",
  "dialogs.node_create_new.success.create": "{fileName} erfolgreich erstellt",
  "dialogs.node_create_new.title": "Neue {file} Datei erstellen",
  "dialogs.remove_deadline": "Frist entfernen",
  "dialogs.rename": "Umbenennen",
  "dialogs.save": "Speichern",
  "dialogs.select_location": "Standort auswählen",
  "dialogs.session_invalid.btn_login": "Anmelden",
  "dialogs.session_invalid.loggedout.msg": "Sie wurden  aus DeepBox abgemeldet. Bitte melden Sie sich erneut an.",
  "dialogs.session_invalid.loggedout.title": "Sie wurden aus DeepBox abgemeldet",
  "dialogs.session_invalid.session_expired.msg": "Aus Sicherheitsgründen wurden Sie aus DeepBox abgemeldet. Bitte melden Sie sich erneut an.",
  "dialogs.session_invalid.session_expired.title": "Sie wurden aus DeepBox abgemeldet",
  "dialogs.tags.most_used_tags": "Vorschlag",
  "dialogs.tags.n_selected": "1 ausgewählt | {n} ausgewählt",
  "dialogs.tags.title": "Tags",
  "dialogs.tags.toast.success.n_updated": "1 Datei wurde erfolgreich aktualisiert | {n} Dateien wurden erfolgreich aktualisiert",
  "dialogs.yes": "Ja",
  "drag_drop.msg.error.missing_permissions_to_add_children": "fehlende Berechtigungen für diese Aktion",
  "drag_drop.msg.error.missing_permissions_to_delete_some_nodes": "1 Element kann nicht gelöscht werden, weil Sie keine Berechtigung dafür haben. Dieses Element wird gefiltert. | {n} Elemente können nicht gelöscht werden, da Sie keine Berechtigung dafür haben. Diese Elemente werden gefiltert.",
  "drag_drop.msg.error.move_to_same_parent": "Datei kann nicht verschoben werden, da der Ausgangsordner gewählt wurde. | Dateien können nicht verschoben werden, da der Ausgangsordner gewählt wurde.",
  "drag_drop.msg.error.target_is_one_of_the_nodes_to_be_moved": "Der Ordner kann nicht in sich verschoben werden",
  "drag_drop.msg.success.node_moved_to_target": "Element wurde erfolgreich in den folgenden Ordner verschoben: \"{targetName}\" | Elemente wurden erfolgreich in den folgenden Ordner verschoben: \"{targetName}\"",
  "error.403.box_elevated_auth_required.btn_2fa": "2FA aktivieren",
  "error.403.box_elevated_auth_required.description": "Der Zugriff verlangt eine Anmeldung mit Zwei-Faktor-Authentifizierung (2FA). Aktivieren Sie 2FA, um auf den freigegebenen Inhalt zugreifen zu können.",
  "error.403.box_elevated_auth_required.link_2fa_info": "Weitere Informationen zu 2FA",
  "error.403.box_elevated_auth_required.title": "Zugriff verweigert",
  "error.403.box_not_found_or_no_access": "Box existiert nicht oder Sie haben keine Berechtigung, um auf die Box zuzugreifen.",
  "error.403.file": "Sie haben keine Berechtigung, um auf das Dokument zuzugreifen.",
  "error.403.file_not_found_or_no_access": "Datei existiert nicht oder Sie haben keine Berechtigung, um auf das Dokument zuzugreifen.",
  "error.403.settings": "Sie haben keine Berechtigung, um auf diese Einstellungen zuzugreifen.",
  "error.403.wrong_account_email": "Die E-Mail des Kontos, mit dem Sie versuchen, dieses Dokument zu signieren, stimmt nicht mit der E-Mail überein, an die die Signaturanforderung gesendet wurde. Bitte melden Sie sich ab und öffnen Sie den Link, den Sie per E-Mail erhalten haben, erneut.",
  "error.413.file_too_big": "Datei zu gross",
  "error.axios.ERR_NETWORK": "Die Verbindung wurde unterbrochen",
  "error.code": "Code",
  "error.codes.ERR_FILE_NOT_FOUND": "Datei nicht gefunden",
  "error.codes.KC_ERROR_UPDATE_TOKEN": "Ungültige Sitzung",
  "error.codes.UPLOAD_PARENT_NODE_ID_CAN_NOT_BE_EMPTY": "Die ID des Elternknotens darf nicht leer sein",
  "error.download.multiple.n_max_length": "Maximal {n} ausgewählte Elemente können gleichzeitig heruntergeladen werden.",
  "error.download.not_possible": "Download nicht möglich",
  "error.email_do_not_match.description": "Sie erstellen einen Account mit der E-Mail <b>{newEmail}</b>, jedoch sind sie noch mit folgender E-Mail angemeldet: <b>{currentEmail}</b>.\n<br />\nBitte melden Sie sich ab, um einen Account mit einer neuen E-Mail zu erstellen.",
  "error.email_do_not_match.title": "E-Mail stimmt nicht überein",
  "error.error_occurred": "Ein Fehler ist aufgetreten",
  "error.home": "Startseite",
  "error.inbox.folders_are_not_allowed": "Ordner werden in der Inbox nicht unterstützt. 1 Ordner wird nicht verschoben. | Ordner werden in der Inbox nicht unterstützt. {n} Ordner werden nicht verschoben.",
  "error.invalid_or_missing_params": "Ungültige oder fehlende Parameter",
  "error.invalid_param_email": "Ungültige E-Mail Parameter",
  "error.invalid_password": "Passwort ungültig",
  "error.invalid_url_service_param": "Ungültiger Service-Parameter",
  "error.key_invalid_or_expired": "Key ist ungültig oder abgelaufen",
  "error.logged_out": "Sie wurden ausgeloggt",
  "error.login": "Zurück zum Login",
  "error.organization_not_found": "Organisation nicht gefunden",
  "error.page_not_found": "Seite nicht gefunden",
  "error.page_not_found_or_missing_permissions": "Seite nicht gefunden oder Sie haben keine Berechtigung, auf diese Ressource zuzugreifen",
  "error.url_invalid": "URL ist ungültig oder abgelaufen",
  "error.validation.invalid": "Bitte prüfen Sie ihre Eingabe",
  "external_services.aba_ninja.description": "Buchhaltungsprogramm eröffnen",
  "external_services.deepmail.description": "Deep Mail versenden",
  "external_services.hoop.description": "Unternehmen digital gründen und ändern",
  "external_services.title": "Durch DeepBox ermöglichte Anwendungen",
  "fields.country_select.label": "Land auswählen",
  "fields.errors.invalid_email": "Das Mail ist ungültig",
  "fields.errors.invalid_password": "Das Passwort entspricht nicht den Validierungsregeln",
  "fields.errors.max_length": "Maximale Länge von {maxLength} wurde überschritten",
  "fields.errors.min_length": "Minimale Länge von {minLength} wurde nicht erreicht",
  "fields.errors.required": "Pflichtfeld",
  "fields.multi_language_text.btn_add": "Sprache hinzufügen",
  "fields.multi_language_text.field_key_label": "Sprache",
  "fields.multi_language_text.field_value_label": "Text",
  "fields.password.label": "Passwort",
  "fields.password_with_verification.hint": "Mindestens {counter} Zeichen (Buchstaben, Ziffern und Symbolen)",
  "fields.phone.placeholder": "Telefonnummer eingeben",
  "fields.search_for_boxes.placeholder": "Boxen suchen",
  "fields.uid.label": "UID",
  "fields.uid.placeholder.country.ch": "z.B. {example}",
  "fields.uid.placeholder.country.row": "UID eingeben",
  "fields.zip_city.city.label": "Ort",
  "fields.zip_city.zip.label": "PLZ",
  "form.de": "Deutsch",
  "form.email": "E-Mail",
  "form.en": "Englisch",
  "form.extension": "Erweiterung",
  "form.fr": "Französisch",
  "form.it": "Italienisch",
  "form.manage_translations": "Übersetzungen verwalten",
  "form.message": "Nachricht",
  "form.name": "Name",
  "form.noDataText": "Keine Daten verfügbar",
  "form.type": "Typ",
  "hints.analysis.failed": "Analyse fehlgeschlagen",
  "hints.analysis.running": "Analyse läuft...",
  "hints.expired": "Abgelaufen",
  "hints.expires": "Läuft ab",
  "hints.n_files": "1 Datei | {n} Dateien",
  "hints.n_folders": "1 Ordner | {n} Ordner",
  "inbox_address.btn_generate": "Neue Adresse generieren",
  "inbox_address.delete.msg": "Sind Sie sicher, dass Sie diese Adresse löschen möchten?",
  "inbox_address.delete.title": "Adresse löschen",
  "inbox_address.delete_address": "Adresse löschen",
  "inbox_address.description": "Generieren Sie eindeutige Adressen über welche Ihnen Dokumente direkt mittels einer E-Mail oder einem Upload Dialog in die Inbox gesendet werden können. Jeder mit Zugang zu diesen Adressen kann Ihnen Dateien zusenden. Seien Sie also vorsichtig mit wem Sie diese teilen. Adressen können jederzeit wieder deaktiviert werden. {link}",
  "inbox_address.description_short": "Generieren Sie eindeutige Adressen über welche Ihnen Dokumente direkt mittels einer E-Mail oder einem Upload Dialog in die Inbox gesendet werden können... {link}",
  "inbox_address.edit.label.description": "Beschreibung",
  "inbox_address.edit.label.email_link": "E-Mail Link",
  "inbox_address.edit.label.upload_link": "Upload Link",
  "inbox_address.manage_all_addresses": "Adressen verwalten",
  "inbox_address.title": "Adresse für diese Inbox",
  "inbox_address.toast.error.email_disabled": "E-Mail Link konnte nicht deaktiviert",
  "inbox_address.toast.error.email_enabled": "E-Mail Link konnte nicht aktiviert",
  "inbox_address.toast.error.upload_disabled": "Upload Link konnte nicht deaktiviert",
  "inbox_address.toast.error.upload_enabled": "Upload Link konnte nicht aktiviert",
  "inbox_address.toast.success.email_disabled": "E-Mail Link wurde erfolgreich deaktiviert",
  "inbox_address.toast.success.email_enabled": "E-Mail Link wurde erfolgreich aktiviert",
  "inbox_address.toast.success.generated": "Adresse wurde erfolgreich generiert",
  "inbox_address.toast.success.saved": "Address wurde erfolgreich gespeichert",
  "inbox_address.toast.success.upload_disabled": "Upload Link wurde erfolgreich deaktiviert",
  "inbox_address.toast.success.upload_enabled": "Upload Link wurde erfolgreich aktiviert",
  "labels.attachments": "Anhänge",
  "labels.boxes_shared_with_me": "Mit mir geteilt",
  "labels.clear_all": "Alle entfernen",
  "labels.description": "Beschreibung",
  "labels.documents_in_inbox": "Dokument in der Inbox | Dokumente in der Inbox",
  "labels.email": "E-Mail",
  "labels.favorite": "Favorite",
  "labels.favorites": "Favoriten",
  "labels.file": "Datei | Dateien",
  "labels.files": "Datei | Dateien",
  "labels.filter": "Filter",
  "labels.folder": "Ordner | Ordner",
  "labels.insufficient_permissions": "Keine Berechtigungen",
  "labels.less": "weniger",
  "labels.load_more": "Nachladen",
  "labels.menu.actions.favorites.add": "Zu Favoriten hinzufügen",
  "labels.menu.actions.favorites.remove": "Aus Favoriten entfernen",
  "labels.more": "mehr",
  "labels.n_elements_selected": "1 Element ausgewählt | {n} Elemente ausgewählt",
  "labels.open": "Öffnen",
  "labels.open_dashboard": "Dashboard öffnen",
  "labels.others": "weiterer | weitere",
  "labels.recents": "Zuletzt",
  "labels.request_message": "Supportanfrage",
  "labels.section": "Bereich",
  "labels.show_all": "Alle anzeigen",
  "labels.show_less": "Weniger anzeigen",
  "labels.show_more": "Mehr anzeigen",
  "labels.suggestions": "Vorschläge",
  "labels.valid_from": "Gültig von",
  "labels.valid_until": "Gültig bis",
  "links.read_more": "Mehr erfahren",
  "loader.files.are_being_indexed": "Die Dateien werden indiziert...",
  "loader.is_loading": "Wird geladen...",
  "main_view.all": "Alle anzeigen",
  "main_view.boxes_shared_with_me": "Mit mir geteilte Boxen",
  "main_view.deadlines": "Fristen",
  "main_view.favorites": "Favoriten",
  "main_view.inbox": "Inbox",
  "main_view.recents": "Zuletzt",
  "main_view.search_for_boxes": "Boxen suchen",
  "messages.error.deepsign_file_max_size": "Nur Dateien mit einer Grösse von bis zu {size} können signiert werden.",
  "messages.error.deepvalidator_file_max_size": "Nur Dateien mit einer Grösse von bis zu {size} können mit DeepValidator geöffnet werden.",
  "messages.error.file_size": "Es können nur Dateien bis zu einer Grösse von 2 GB hochgeladen werden.",
  "messages.no_box_found": "Es konnte keine Box gefunden werden.",
  "messages.no_boxes_found": "Keine Boxen gefunden",
  "messages.no_boxes_found_title": "Keine Boxen",
  "messages.success.box_created": "Box erfolgreich erstellt",
  "messages.success.copy_of": "Kopie von {fileName} erfolgreich erstellt | Kopie von {n} Dateien erfolgreich erstellt",
  "messages.success.delete": "1 Dokument in den Papierkorb verschoben | {n} Dokumente in den Papierkorb verschoben",
  "messages.success.delete_permanently": "1 Dokument dauerhaft gelöscht | {n} Dokumente dauerhaft gelöscht",
  "messages.success.file_converted_to_pdf": "Datei {fileName} erfolgreich erstellt | {n} PDF-Dateien erfolgreich erstellt",
  "messages.success.file_upload": "Es wurden keine Elemente auf {destination} hochgeladen | {number} Dokument wurde auf {destination} hochgeladen | {number} Elemente wurden auf {destination}hochgeladen",
  "messages.success.folder_created": "Ordner {name} wurde erfolgreich erstellt.",
  "messages.success.folder_upload": "Der Ordner {destination} wurde erstellt.  | Der Ordner {destination} wurde erstellt und {number} Dokument wurden darin hochgeladen. Der Ordner {destination} wurde erstellt und {number} Dokumente wurden darin hochgeladen.",
  "messages.success.move": "Keine Elemente wurden nach {destination} verschoben | {n} Element wurde nach {destination} verschoben | {n} Elemente wurden nach {destination} verschoben",
  "messages.success.move_to_box_element": "Kein Element wurde in den Ordner \"{folderName}\" der Box \"{boxName}\" verschoben | {n} Element wurde in den Ordner \"{folderName}\" der Box \"{boxName}\" verschoben | {n} Elemente wurden in den Ordner \"{folderName}\" der Box \"{boxName}\" verschoben",
  "messages.success.move_to_box_file": "Keine Datei wurde in den Ordner \"{folderName}\" der Box \"{boxName}\" verschoben | {n} Datei wurde in den Ordner \"{folderName}\" der Box \"{boxName}\" verschoben | {n} Dateien wurden in den Ordner \"{folderName}\" der Box \"{boxName}\" verschoben",
  "messages.success.restore": "1 Dokument erfolgreich wiederhergestellt | {n} Dokumente erfolgreich wiederhergestellt",
  "msgbox.btn_agree": "Bestätigen",
  "msgbox.btn_cancel": "Abbrechen",
  "msgbox.checkbox.validation.required": "Pflichtfeld",
  "navigation.collapse": "Einklappen",
  "navigation.dashboard": "Dashboard",
  "navigation.deepbox_settings": "Box Einstellungen",
  "navigation.deepo_settings": "DeepO Einstellungen",
  "navigation.expand": "Ausklappen",
  "navigation.of": "{currentFile} von {filesNumber}",
  "navigation.recent": "Letzte",
  "navigation.recent_boxes": "Letzte Boxen",
  "navigation.tabs.all": "Alle Boxen",
  "navigation.tabs.favorites": "Favoriten",
  "navigation.tabs.files": "Dokumente",
  "navigation.tabs.inbox": "Inbox",
  "navigation.tabs.recent": "Zuletzt",
  "navigation.tabs.trash": "Papierkorb",
  "no_box.box_name": "Box meiner Firma",
  "no_box.button_text": "Richten Sie Ihre eigene DeepBox ein",
  "no_box.features.automate_document_processing": "Dokumentenverarbeitung automatisieren",
  "no_box.features.connect": "Verbindung mit Dritten",
  "no_box.features.share_documents": "Dokumente mit anderen teilen",
  "no_box.features.store_your_documents": "Speichern Sie Ihre eigenen Dokumente",
  "no_box.title": "Musterfirma AG",
  "node.cloudoffice.msg_box.terms.member.content": "Der Dienst Microsoft 365 web ist von Ihrer Organisation noch nicht freigeschaltet. {link}",
  "node.cloudoffice.msg_box.terms.member.title": "Nicht freigeschaltet",
  "node.cloudoffice.msg_box.terms.owner.checkbox.label": "Ich akzeptiere die Bedingungen.",
  "node.cloudoffice.msg_box.terms.owner.content": "Für die Bearbeitung von Dateien nutzen Sie einen Microsoft-Dienst. Bitte bestätigen Sie, dass Sie die Microsoft-Nutzungsbedingungen und deren Datenschutzrichtlinien akzeptieren. Ausserdem gelten die Nutzungsbestimmungen der DeepCloud REST API.",
  "node.cloudoffice.msg_box.terms.owner.title": "Microsoft 365 web",
  "node.download.errors.av_scan_file_too_big.btn.agree": "Trotzdem herunterladen",
  "node.download.errors.av_scan_file_too_big.checkbox.label": "Ich verstehe die Risiken und möchte die Datei trotzdem runterladen | Ich verstehe die Risiken und möchte die Dateien trotzdem runterladen",
  "node.download.errors.av_scan_file_too_big.message": "Die Datei konnte nicht auf Viren überprüft werden, da diese zu gross ist. <br />\nDie Datei könnte schädlich sein, also laden Sie diese nur runter, wenn Sie die Risiken verstehen. | Mindestens eine Datei konnte nicht auf Viren überprüft werden, da diese zu gross ist. <br />\nDie Dateien könnten schädlich sein, also laden Sie diese nur runter, wenn Sie die Risiken verstehen.",
  "node.download.errors.av_scan_file_too_big.title": "Virusscan fehlgeschlagen",
  "node.download.errors.av_scan_virus_found.btn.agree": "Trotzdem herunterladen",
  "node.download.errors.av_scan_virus_found.checkbox.label": "Ich verstehe die Risiken und möchte die Datei trotzdem runterladen | Ich verstehe die Risiken und möchte die Dateien trotzdem runterladen",
  "node.download.errors.av_scan_virus_found.message": "Unser Virusscanner hat einen Virus in dieser Datei gefunden. <br />\nWir empfehlen Ihnen die Datei nicht runterzuladen, da diese schädlich sein könnten. | Unser Virenscanner hat einen Virus in mind. einer Datei gefunden. <br />\nWir empfehlen Ihnen die Dateien nicht runterzuladen, da diese schädlich sein könnten.",
  "node.download.errors.av_scan_virus_found.title": "ACHTUNG: Virus gefunden",
  "node.download.errors.av_scan_virus_found_and_file_too_big.btn.agree": "Trotzdem herunterladen",
  "node.download.errors.av_scan_virus_found_and_file_too_big.checkbox.label": "Ich verstehe die Risiken und möchte die Datei trotzdem herunterladen | Ich verstehe die Risiken und möchte die Dateien trotzdem herunterladen",
  "node.download.errors.av_scan_virus_found_and_file_too_big.message": "Unser Virenscanner hat einen Virus in dieser Datei gefunden oder diese Datei konnte aufgrund der Grösse nicht überprüft werden.<br />\nWir empfehlen Ihnen die Datei nicht herunterzuladen, da diese schädlich sein könnten. | Unser Virenscanner hat einen Virus in mind. einer Datei gefunden oder mind. eine Datei konnte aufgrund der Grösse nicht überprüft werden.<br />\nWir empfehlen Ihnen die Dateien nicht herunterzuladen, da diese schädlich sein könnten.",
  "node.download.errors.av_scan_virus_found_and_file_too_big.title": "Achtung!",
  "node.download.success": "Download folgt",
  "node.download.zip_snackbar.generating_zip_file": "ZIP-Datei wird erstellt | {n} ZIP-Dateien werden erstellt",
  "node.download.zip_snackbar.zip_download": "ZIP Download",
  "node.preview.errors.av_scan_file_too_big.btn.agree": "Trotzdem anzeigen",
  "node.preview.errors.av_scan_file_too_big.checkbox.label": "Ich verstehe die Risiken und möchte die Datei trotzdem anzeigen | Ich verstehe die Risiken und möchte die Dateien trotzdem anzeigen",
  "node.preview.errors.av_scan_file_too_big.message": "Diese Datei konnte nicht auf Viren überprüft werden, da diese zu gross ist.<br />\nDie Datei könnte schädlich sein, also sehen Sie sie sich daher nur an, wenn Sie die Risiken verstehen.",
  "node.preview.errors.av_scan_file_too_big.title": "Virusscan fehlgeschlagen",
  "node.preview.errors.av_scan_virus_found.btn.agree": "Trotzdem Anzeigen",
  "node.preview.errors.av_scan_virus_found.checkbox.label": "Ich verstehe die Risiken und möchte die Datei trotzdem anzeigen",
  "node.preview.errors.av_scan_virus_found.message": "Unser Virusscanner hat einen Virus in dieser Datei gefunden.<br />\nDie Datei könnte schädlich sein, also sehen Sie sie sich daher nur an, wenn Sie die Risiken verstehen.",
  "node.preview.errors.av_scan_virus_found.title": "ACHTUNG! Virus gefunden",
  "node.share_link.errors.av_scan_file_too_big.btn.agree": "Trotzdem teilen",
  "node.share_link.errors.av_scan_file_too_big.checkbox.label": "Ich verstehe die Risiken und möchte die Datei trotzdem teilen | Ich verstehe die Risiken und möchte die Dateien trotzdem teilen",
  "node.share_link.errors.av_scan_file_too_big.message": "Die Datei konnte nicht auf Viren überprüft werden, da diese zu gross ist (<b>{fileSize}</b>).<br />Die Datei könnte schädlich sein, also teilen Sie diese nur, wenn Sie die Risiken verstehen.",
  "node.share_link.errors.av_scan_file_too_big.title": "Virusscan fehlgeschlagen",
  "node.virus.table.headers.file": "Datei",
  "node.virus.table.headers.virus_signature": "Virus Signatur",
  "node_data_table.actions.add_deadline": "Frist hinzufügen",
  "node_data_table.actions.analyze": "Analysieren",
  "node_data_table.actions.assign_tags": "Tags hinzufügen",
  "node_data_table.actions.continue_deepsign": "Weiter auf DeepSign",
  "node_data_table.actions.convert_to_pdf": "In PDF konvertieren",
  "node_data_table.actions.copy_of": "Kopie erstellen",
  "node_data_table.actions.deepa_chat": "Mit DeepA chatten",
  "node_data_table.actions.deepmail": "Mit DeepMail versenden",
  "node_data_table.actions.delete_permanently": "Dauerhaft löschen",
  "node_data_table.actions.details_deepsign": "Details zu DeepSign anzeigen",
  "node_data_table.actions.download": "Herunterladen",
  "node_data_table.actions.edit": "Bearbeiten",
  "node_data_table.actions.edit_deadline": "Frist bearbeiten",
  "node_data_table.actions.edit_tags": "Tags bearbeiten",
  "node_data_table.actions.flow_start": "Flow starten",
  "node_data_table.actions.group.actions": "Aktionen",
  "node_data_table.actions.group.organize": "Organisieren",
  "node_data_table.actions.hidden": "Versteckt",
  "node_data_table.actions.move_to": "Verschieben nach",
  "node_data_table.actions.move_to_trash": "In den Papierkorb verschieben",
  "node_data_table.actions.pay": "Zahlen",
  "node_data_table.actions.pdf_compare": "PDFs vergleichen",
  "node_data_table.actions.rename": "Umbenennen",
  "node_data_table.actions.restore": "Wiederherstellen",
  "node_data_table.actions.share_link": "Link teilen",
  "node_data_table.actions.show_details": "Details anzeigen",
  "node_data_table.actions.sign": "Mit DeepSign unterschreiben",
  "node_data_table.actions.summarization": "Zusammenfassen mit DeepA",
  "node_data_table.headers.date": "Datum",
  "node_data_table.headers.deleted.time": "Gelöscht",
  "node_data_table.headers.deleted.user": "Gelöscht durch",
  "node_data_table.headers.document_type": "Typ",
  "node_data_table.headers.location": "Standort",
  "node_data_table.headers.modified": "Geändert",
  "node_data_table.headers.name": "Name",
  "node_data_table.headers.owner": "Eigentümer",
  "node_data_table.headers.received": "Eingang",
  "node_data_table.headers.retained_until": "Aufbewahrt bis",
  "node_data_table.headers.signature": "Unterschrift",
  "node_data_table.headers.size": "Grösse",
  "node_data_table.headers.timestamp": "Zeitstempel",
  "node_data_table.me": "Ich",
  "node_data_table.mobile.sort_keys.largest": "Grösste",
  "node_data_table.mobile.sort_keys.name_asc": "Name aufsteigend",
  "node_data_table.mobile.sort_keys.name_desc": "Name absteigend",
  "node_data_table.mobile.sort_keys.newest": "Neuste",
  "node_data_table.mobile.sort_keys.oldest": "Älteste",
  "node_data_table.mobile.sort_keys.smallest": "Kleinste",
  "node_data_table.sign": "Signieren",
  "node_data_table.tags": "Tags",
  "node_data_table.tags_multiple": "Mehrere Tags",
  "node_data_table.tooltip.comment": "Kommentieren",
  "node_data_table.tooltip.comments_show": "Kommentare anzeigen",
  "node_data_table.tooltip.sign_status_pending": "Signatur(en) ausstehend",
  "node_data_table.tooltip.sign_status_signed": "Vollständig signiert",
  "node_data_table.views.hidden": "Versteckte Elemente anzeigen",
  "node_data_table.views.list": "Grosse Liste",
  "node_data_table.views.list_dense": "Liste",
  "nodes.convert_to_pdf_and_sign_msg_box.checkbox.label": "Nicht mehr anzeigen",
  "nodes.convert_to_pdf_and_sign_msg_box.errors.file_to_big_mb": "Die Datei ist zu gross. Die maximale Dateigrösse beträgt {maxFileSize} MB",
  "nodes.convert_to_pdf_and_sign_msg_box.msg": "Eine PDF-Kopie Ihres Dokuments wird zum Signieren mit DeepSign erstellt und am gleichen Ort in Ihrer DeepBox gespeichert.",
  "nodes.convert_to_pdf_and_sign_msg_box.msg_converting_file_to_pdf": "Die Datei wird in PDF konvertiert",
  "nodes.convert_to_pdf_and_sign_msg_box.title": "PDF zum Signieren wird erstellt",
  "nodes.files_description_types.audio": "Audio",
  "nodes.files_description_types.document": "Dokument",
  "nodes.files_description_types.file": "Datei",
  "nodes.files_description_types.image": "Bild",
  "nodes.files_description_types.video": "Video",
  "nodes.upload_card.labels.count_error": "1 fehlgeschlagen | {n} fehlgeschlagen",
  "nodes.upload_card.labels.count_n_of_total": "{n} von {total} Elementen",
  "nodes.upload_card.title": "Uploads",
  "onlyoffice.editor.open_file_location": "Speicherort der Datei öffnen",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.admin_or_member.actions.support": "DeepCloud",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.admin_or_member.text": "Es bestehen mehrere offene Rechnungen, die bezahlt werden müssen. Aus diesem Grund wurde der Account gesperrt. Bitte kontaktieren Sie Ihren Administrator, um den Account wieder freizuschalten.",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.owner.actions.open_invoices": "Zu den Rechnungen",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.owner.text": "Es bestehen mehrere offene Rechnungen, die bezahlt werden müssen. Aus diesem Grund wurde der Account gesperrt. Bitte begleichen Sie die offenen Rechnungen, um den Account wieder freizuschalten.",
  "overlays.overused_subscription.has_a_blocking_amount_of_open_invoices.title": "Ausstehende Zahlungen",
  "overlays.overused_subscription.has_overused_box_users.admin_or_member.text": "Ihre DeepBox hat entweder zu viele Nutzer oder zu viele Boxen im Einsatz, als was aktuell über Ihr Abonnement verfügbar ist. Bitte informieren Sie die Owner dieser DeepBox, damit diese das Abonnement anpassen können.",
  "overlays.overused_subscription.has_overused_box_users.owner.actions.manage_organization": "Organisation verwalten",
  "overlays.overused_subscription.has_overused_box_users.owner.actions.manage_subscription": "Abonnement verwalten",
  "overlays.overused_subscription.has_overused_box_users.owner.text": "Ihre DeepBox hat entweder zu viele Nutzer oder zu viele Boxen im Einsatz, als was aktuell über Ihr Abonnement verfügbar ist. Bitte lösen Sie für diese DeepBox ein entsprechendes Abonnement oder entfernen Sie Nutzer bzw. Boxen.",
  "overlays.overused_subscription.has_overused_box_users.title": "Es muss ein Abonnement gelöst werden, um diese DeepBox weiter nutzen zu können.",
  "overlays.overused_subscription.learn_more": "Erfahren Sie hier mehr über DeepBox Abonnemente: ",
  "overlays.overused_subscription.title": "Abonnement",
  "page_titles.search_results": "Suchergebnisse",
  "pages.dashboard.deadlines": "Fristen",
  "pages.dashboard.empty.text": "Ihre Boxen werden hier angezeigt",
  "pages.dashboard.empty.text_can_not_onboard": "Sie haben die nötigen Rechte nicht, um eine Box anzulegen. <br /> \nNehmen Sie mit einen Owner oder Admin Ihrer Organisation Kontakt auf.",
  "pages.dashboard.empty.text_create_box": "Erstellen Sie kostenlos Ihre erste Box, um die Schweizer All-in-One-Plattform für den sicheren Dokumentenaustausch zu nutzen.",
  "pages.dashboard.empty.title": "Keine Boxen verfügbar",
  "pages.dashboard.inbox": "Inbox",
  "pages.dashboard.labels.all_sections": "Alle Bereiche",
  "pages.dashboard.labels.display_all_n": "Alle anzeigen ({n})",
  "pages.dashboard.labels.tabs": "Tabs",
  "pages.dashboard.onboarding.banner.actions.continue": "Onboarding fortsetzen",
  "pages.dashboard.onboarding.banner.text_in_progress": "Um DeepBox selber nutzen zu können, müssen Sie das Onboarding fertig durchführen.",
  "pages.dashboard.onboarding.banner.text_not_started": "Um DeepBox selber nutzen zu können, müssen Sie Ihr Konto vervollständigen.",
  "pages.dashboard.private_box_title": "Für Sie",
  "pages.links.alert_info": "Dieser Link läuft in 1 Tag ab | Dieser Link läuft in {n} Tagen ab",
  "pages.links.alert_msg_date_expired": "Der Link ist ungültig",
  "pages.links.btn_download": "Herunterladen",
  "pages.links.btn_view": "Anschauen",
  "pages.links.file_preview_not_available": "Die Datei kann nicht in der Vorschau angezeigt werden.",
  "pages.store.services.aba_ninja.category": "Buchhaltung",
  "pages.store.services.aba_ninja.content": "<div>\nDeepNinja ist das Buchhaltungsprogramm, mit dem Sie einfach die Finanzen Ihres Unternehmens verwalten können. Das effiziente Tool für Offerten, Rechnungen, Zahlungen, Zeiterfassungen und vieles mehr, unterstützt Sie bei den administrativen Aufgaben. Dank der neuen DeepBox/DeepNinja Verbindung können Dokumente einfach ausgetauscht und dann direkt automatisch mit dem Buchhaltungsprogramm verarbeitet werden.\n</div>\n<br />\n<div>\nHiermit können Sie direkt ein DeepNinja Konto eröffnen und mit Ihrer DeepBox verbinden.\n</div>\n<div class=\"mt-4\">Ihre Vorteile:</div>\n<ul>\n  <li>Offerten & Rechnungen erstellen, versenden und in DeepBox ablegen</li>\n  <li>Automatische Verarbeitung von Lieferanten-Rechnungen mit DeepBox</li>\n  <li>Einfache Zeit- und Leistungserfassung</li>\n  <li>Direkte Anbindung an Abacus ERP Finanzbuchhaltung</li>\n</ul>",
  "pages.store.services.aba_ninja.languages": "Deutsch, Französich, Italienisch, Englisch",
  "pages.store.services.aba_ninja.price": "CHF 21.- pro Monat",
  "pages.store.services.aba_ninja.subtitle": "Buchhaltungsprogramm",
  "pages.store.services.aba_ninja.title": "DeepNinja",
  "pages.store.services.hoop.category": "Firmengründung",
  "pages.store.services.hoop.content": "<div>\nHoop ist die innovative Anwendung für Treuhänder von DeepBox, mit der Firmen einfach und 100 % digital gegründet werden können. Von der Eingabe der Gründungsdaten über die Eröffnung des Kapitaleinzahlungskontos bis hin zur Eintragung ins Handelsregister ist der Prozess konsequent digitalisiert und beinhaltet alle Phasen der Firmengründung.\n</div>\n<div class=\"mt-4\">Ihre Vorteile:</div>\n<ul>\n  <li>Einfacher und 100% digitaler Prozess</li>\n  <li>Hoop wird für alle Fragen Ihr einziger Ansprechpartner sein</li>\n  <li>Online-Eröffnung des Kapitaleinzahlungskontos</li>\n  <li>Notarielle Bescheinigung mit integrierter digitaler Signatur</li>\n  <li>Sämtliche Unterlagen werden zentral in der DeepBox archiviert</li>\n</ul>\n<div class=\"mt-4\">Mögliche Rechtsformen:</div>\n<ul>\n  <li>Einzelunternehmen</li>\n  <li>Gesellschaft mit beschränkter Haftung (GmbH)</li>\n  <li>Aktiengesellschaft (AG)</li>\n</ul>",
  "pages.store.services.hoop.languages": "Deutsch, Französich, Italienisch, Englisch",
  "pages.store.services.hoop.links.contact": "Kontaktieren",
  "pages.store.services.hoop.links.title": "Hoop Corporate Services SA",
  "pages.store.services.hoop.links.website": "Website",
  "pages.store.services.hoop.price": "CHF 490.- für Einzelgründung ",
  "pages.store.services.hoop.subtitle": "Digitalisierter Prozess zur Firmengründung ",
  "pages.store.services.hoop.title": "Hoop – Firmengründung",
  "pages.upload.add_more_files": "Weitere Dateien hinzufügen",
  "pages.upload.dialog_unsupported_files.text": "Es hat 1 nicht unterstützte Datei. \nDiese Datei wird nicht hochgeladen.\n| Es hat {n} nicht unterstützte Dateien.\nDiese Dateien werden nicht hochgeladen.",
  "pages.upload.dialog_unsupported_files.title": "Nicht unterstütze Dateien",
  "pages.upload.errors.invalid_url": "Die Upload-Seite ist nicht gültig. Bitte kontaktieren Sie einen Administrator dieser DeepBox. ",
  "pages.upload.errors.not_found": "Die Dateien konnten nicht hochgeladen werden. Bitte laden Sie die Seite neu.",
  "pages.upload.errors.upload_failed": "Einige Dateien konnten nicht hochgeladen werden. Bitte versuchen Sie es erneut.",
  "pages.upload.text_intro": "Mit dem Direkt Upload können Sie Dateien direkt zur Box {box} von {organization} übermitteln.",
  "pages.upload.text_link_validity": "Der Upload Link läuft in {n} ab.",
  "pages.upload.title": "Dateien hochladen",
  "pages.upload.upload_error": "1 Datei konnte nicht hochgeladen werden | {n} Dateien konnten nicht hochgeladen werden",
  "pages.upload.upload_success": "1 Datei wurde erfolgreich hochgeladen | {n} Dateien wurden erfolgreich hochgeladen",
  "placeholders.enter_support_request": "Geben Sie hier die Beschreibung Ihrer Anfrage ein...",
  "placeholders.filter_by_owner": "Nach Besitzer filtern",
  "placeholders.filter_by_tags": "Nach Tags filtern",
  "placeholders.search": "Suchen...",
  "placeholders.search_box": "Box suchen...",
  "placeholders.search_in_box": "Suche in {box} ",
  "placeholders.search_tags": "Tags suchen...",
  "placeholders.select": "Auswählen",
  "pocs.deep_docs.box.filters.changed_by_me.title": "Von mir geändert",
  "pocs.deep_docs.box.filters.favorites.title": "Favoriten",
  "pocs.deep_docs.box.filters.flow.title": "Im Flow",
  "pocs.deep_docs.box.filters.recents.title": "Zuletzt",
  "pocs.deep_docs.box.group_by.assignee.title": "Zugewiesen",
  "pocs.deep_docs.box.group_by.document_type.title": "Dokumentyp",
  "pocs.deep_docs.box.group_by.flow.title": "Flow",
  "pocs.deep_docs.box.group_by.none.title": "Keine",
  "pocs.deep_docs.box.group_by.owner.title": "Besitzer",
  "pocs.deep_docs.box.group_by.project.title": "Projekt",
  "pocs.deep_docs.box.group_by.type.title": "Typ",
  "pocs.deep_docs.node_actions.copy.toast_messages.success": "Kopie von {fileName} erfolgreich erstellt | Kopie von {n} Dateien erfolgreich erstellt",
  "pocs.deep_docs.node_actions.download.toast.preparing_download": "Ihr Download wird vorbereitet ...",
  "pocs.deep_docs.node_actions.move_to.toast_messages.readonly_folders": "Elemente mit nur Leserecht können nicht verschoben werden.",
  "pocs.deep_docs.node_actions.move_to.toast_messages.successfully_moved": "Elemente erfolgeich verschoben",
  "pocs.deep_docs.node_actions.move_to_inbox.toast_messages.successfully_moved": "Elemente erfolgeich in die Inbox verschoben",
  "pocs.deep_docs.node_details.attributes.assign_to_me": "Mir zuweisen",
  "pocs.deep_docs.pages.assigned.subtitle": "Dokumente, die auf Ihre Aktion warten.",
  "pocs.deep_docs.pages.assigned.title": "Mir zugewiesen",
  "pocs.deep_docs.pages.dashboard.subtitle": "Das passiert gerade in Ihrem Arbeitsbereich.",
  "pocs.deep_docs.pages.dashboard.title": "Dashboard",
  "pocs.deep_docs.pages.favorites.subtitle": "Ihre favorisierten Dokumente.",
  "pocs.deep_docs.pages.favorites.title": "Favoriten",
  "pocs.deep_docs.pages.inbox.subtitle": "Neu eingegangene Dokumente.",
  "pocs.deep_docs.pages.inbox.title": "Inbox",
  "pocs.deep_docs.pages.recents.subtitle": "Zuletzt aktualisierte Dokumente.",
  "pocs.deep_docs.pages.recents.title": "Zuletzt",
  "pocs.deep_docs.pages.trash.subtitle": "Gelöschte Dokumente.",
  "pocs.deep_docs.pages.trash.title": "Papierkorb",
  "preview.analyse.btn_action": "Analysieren",
  "preview.analyse.loader_is_being_analysed": "Dokument wird gerade analysiert",
  "preview.analyse.text": "Dieses Dokument wurde noch nicht analysiert.",
  "preview.analyse.toaster.success": "Dokument wurde analysiert",
  "preview.cant_be_previewed": "Die Datei kann nicht in der Vorschau angezeigt werden.",
  "preview.dialog.password.text": "Bitte geben Sie das Passwort der Datei ein",
  "preview.dialog.password.text_retry": "Bitte geben Sie das Passwort der Datei erneut ein",
  "preview.dialog.password.title": "Passwortgeschützte Datei",
  "preview.node_actions.text_download": "Herunterladen",
  "preview.node_actions.text_pages": "{currentPage} von {totalPages} Seiten",
  "preview.node_actions.text_print": "Drucken",
  "preview.not_available": "Keine Vorschau vorhanden",
  "preview.rendering": "Rendern läuft...",
  "preview.toaster.error.document_loading_failed": "Es ist ein Fehler beim Laden des Dokuments aufgetreten. Bitte probieren Sie es später erneut.",
  "search.advanced": "Fortgeschrittene...",
  "search.current": "Aktueller Standort - {location}",
  "search.enter_some_text": "Geben Sie einen Text in das Suchfeld ein...",
  "search.everywhere": "Überall -  {location}",
  "search.in": "In",
  "search.instructions.lede": "Die Eingabe eines oder mehrerer Begriffe genügt für eine einfache Suche, die relevantesten Dateien erscheinen zuoberst. Für gezieltere Abfragen lassen sich die untenstehenden Operatoren kombinieren.",
  "search.instructions.note.tip1": "Die Gross- und Kleinschreibung der Suchbegriffe ist unerheblich, <b>bericht</b> findet auch <b>Bericht</b>.",
  "search.instructions.note.tip2": "Eine höhere Anzahl an Begriffen führt zu mehr potenziellen Treffern. Die relevantesten Ergebnisse erscheinen zuoberst.",
  "search.instructions.section1.description": "Mehrere Wörter erweitern die Suche. Dateien, die alle Begriffe enthalten, werden automatisch höher eingestuft.",
  "search.instructions.section1.example1.description": "Alle Dateien, die <b>bericht</b> enthalten.",
  "search.instructions.section1.example1.query": "bericht",
  "search.instructions.section1.example2.description": "<b>bericht</b> oder <b>budget</b>, Treffer mit beiden Begriffen stehen zuoberst.",
  "search.instructions.section1.example2.query": "bericht budget",
  "search.instructions.section1.example3.description": "Nur die exakte Wortfolge <b>Jahresbericht 2024</b>.",
  "search.instructions.section1.example3.query": "\"Jahresbericht 2024\"",
  "search.instructions.section1.example4.description": "<b>vertrag</b> oder die Phrase <b>Jahresbericht 2024</b>.",
  "search.instructions.section1.example4.query": "vertrag \"Jahresbericht 2024\"",
  "search.instructions.section1.title": "Suche nach Begriffen",
  "search.instructions.section2.description": "Ein vorangestelltes + macht einen Begriff zur Pflicht, ein − schliesst ihn aus.",
  "search.instructions.section2.example1.description": "Muss <b>bericht</b> enthalten, <b>budget</b> ist optional.",
  "search.instructions.section2.example1.query": "+bericht budget",
  "search.instructions.section2.example2.description": "<b>bericht</b>, aber ohne <b>entwurf</b>.",
  "search.instructions.section2.example2.query": "bericht -entwurf",
  "search.instructions.section2.example3.description": "Muss beide Begriffe enthalten.",
  "search.instructions.section2.example3.query": "+bericht +budget",
  "search.instructions.section2.example4.description": "Phrase <b>Jahresbericht 2024</b>, ohne <b>entwurf</b>.",
  "search.instructions.section2.example4.query": "\"Jahresbericht 2024\" -entwurf",
  "search.instructions.section2.title": "Pflicht- und Ausschlusskriterien",
  "search.instructions.section3.description": "Die Operatoren sind in Grossbuchstaben zu schreiben. Klammern gruppieren zusammengehörige Bedingungen.",
  "search.instructions.section3.example1.description": "Muss beide Begriffe enthalten.",
  "search.instructions.section3.example1.query": "bericht AND budget",
  "search.instructions.section3.example2.description": "Mindestens einer der beiden Begriffe.",
  "search.instructions.section3.example2.query": "rechnung OR quittung",
  "search.instructions.section3.example3.description": "<b>bericht</b>, aber ohne <b>entwurf</b>.",
  "search.instructions.section3.example3.query": "bericht NOT entwurf",
  "search.instructions.section3.example4.description": "(<b>rechnung</b> oder <b>quittung</b>) und <b>2024</b>.",
  "search.instructions.section3.example4.query": "(rechnung OR quittung) AND 2024",
  "search.instructions.section3.example5.description": "<b>bericht</b> und eine der beiden Phrasen.",
  "search.instructions.section3.example5.query": "bericht AND (\"Q3 2024\" OR \"Q4 2024\")",
  "search.instructions.section3.title": "Verknüpfung mit AND, OR, NOT",
  "search.instructions.title": "Suchhilfe",
  "search.location": "Standort",
  "search.modified": "Geändert",
  "search.modified_14d": "Vor 14 Tagen",
  "search.modified_1h": "Vor 1 Stunde",
  "search.modified_24h": "Vor 24 Stunden",
  "search.modified_30d": "Vor 30 Tagen",
  "search.modified_7d": "Vor 7 Tagen",
  "search.modified_pick_date": "Datum wählen…",
  "search.modified_range_last_12m": "Letzte 12 Monate",
  "search.modified_range_last_30d": "Letzte 30 Tage",
  "search.modified_range_last_3m": "Letzte 3 Monate",
  "search.modified_range_last_7d": "Letzte 7 Tage",
  "search.modified_range_month_to_date": "Dieser Monat",
  "search.modified_range_today": "Heute",
  "search.modified_range_year_to_date": "Dieses Jahr",
  "search.more_locations": "Weitere Standorte",
  "search.no_results": "Keine Ergebnisse",
  "search.no_results_title": "Keine Objekte gefunden",
  "search.no_results_title_location": "Keine Objekte gefunden in {location}",
  "search.owner": "Eigentümer",
  "search.results_found": "Keine Ergebnisse für \"{searchTerm}\" | {n} Suchergebnis für \"{searchTerm}\" | {n} Suchergebnisse für \"{searchTerm}\"",
  "search.search_everywhere_link": "Überall suchen",
  "search.select_location": "Standort auswählen...",
  "search.tags": "Tags",
  "search.title": "Suchergebnisse",
  "seo.description": "Effektive, kollaborative Bearbeitung Ihrer Dokumente. Sicheres Speichern und Teilen von Dokumenten mit Ihrem Computer oder Mobilgerät.",
  "services.download.snackbar.generate_in_progress": "ZIP File wird generiert...",
  "services.download.snackbar.generate_success": "ZIP erstellt. Datei wird runtergeladen...",
  "store.app_bar.btn_cancel": "Abbrechen",
  "store.app_bar.title": "DeepBox ermöglichte Anwendung",
  "store.services.container.bottom.category": "Kategorie",
  "store.services.container.bottom.languages": "Sprachen",
  "store.services.container.bottom.price": "Preis",
  "test.weblate": "Test weblate source code",
  "toast.box.favorites.success_added": "Box \"{boxName}\" wurde erfolgreich zu den Favoriten hinzugefügt.",
  "toast.box.favorites.success_removed": "Box \"{boxName}\" wurde erfolgreich aus den Favoriten entfernt.",
  "toast.error.copy_value": "Der Wert konnte nicht kopiert werden",
  "toast.success.copy_value": "Der Wert wurde erfolgreich kopiert",
  "tooltip.icons.copy": "Kopieren",
  "tooltip.icons.deepa_chat": "DeepA Chat",
  "tooltip.icons.deepadmin_profile": "DeepBox verwalten",
  "tooltip.icons.delete": "Löschen",
  "tooltip.icons.delete_all": "Alles löschen",
  "tooltip.icons.details_panel": "Detailleiste",
  "tooltip.icons.download": "Herunterladen",
  "tooltip.icons.edit": "Bearbeiten",
  "tooltip.icons.help_and_support": "Hilfe/Support",
  "tooltip.icons.move": "Verschieben",
  "tooltip.icons.qr_code": "QR-Code scannen",
  "tooltip.icons.search_filter": "Suchfilter",
  "tooltip.icons.search_instructions": "Suchhilfe",
  "tooltip.icons.view_raw": "Rohansicht",
  "tooltip.icons.view_rendered": "Gerendert Ansicht",
  "tooltip.open": "Öffnen",
  "upload.dropzone.add_files": "Dateien hinzufügen",
  "upload.dropzone.add_files_more": "Weitere Dateien hinzufügen",
  "upload.dropzone.default_hint": "Drag & Drop oder Dateien hochladen",
  "upload.dropzone.dict_cancel_upload": "Hochladen abbrechen",
  "upload.dropzone.dict_fallback_message": "Ihr Browser unterstützt Drag&Drop Dateiuploads nicht",
  "upload.dropzone.dict_fallback_text": "Benutzen Sie das Formular um Ihre Dateien hochzuladen",
  "upload.dropzone.dict_file_too_big": "Die Datei ist zu gross. Die maximale Dateigrösse beträgt {'{'}{'{'}maxFilesize{'}'}{'}'} MB",
  "upload.dropzone.dict_invalid_file_type": "Eine Datei dieses Typs kann nicht hochgeladen werden",
  "upload.dropzone.dict_max_files_exceeded": "Sie können keine weiteren Dateien mehr hochladen",
  "upload.dropzone.dict_remove_file": "Datei entfernen",
  "upload.dropzone.dict_response_error": "Der Server hat ihre Anfrage mit Status {'{'}{'{'}statusCode{'}'}{'}'} abgelehnt.",
  "upload.dropzone.dict_upload_canceled": "Hochladen wurde abgebrochen",
  "upload.dropzone.files_count_added": "1 Datei hinzugefügt | {n} Dateien hinzugefügt",
  "upload.dropzone.files_count_unsupported": "{n} nicht unterstützt",
  "upload.error.axios.ERR_CANCELED": "Der Upload wurde abgebrochen",
  "upload.folders": "Ordner | Ordner",
  "upload.hints.drop_here_to_upload_to": "Dateien ablegen, um sie hier hochzuladen:",
  "upload.items": "Datei | Dateien",
  "upload.no-permissions": "Sie haben keine Berechtigung Dateien hochzuladen.",
  "upload.no_items": "Keine Uploads",
  "upload.status.added": "Hinzugefügt",
  "upload.status.canceled": "Abgebrochen",
  "upload.status.completed": "Abgeschlossen",
  "upload.status.error": "Fehlgeschlagen",
  "upload.status.processing": "In Verarbeitung",
  "upload.status.warning": "Warnung",
  "upload.uploaded_folders": "{folderName} hochgeladen. | {folderName} {n} von {total} hochgeladen.",
  "upload.uploaded_items": "1 Element wurde hochgeladen. | {n} von {total} Elementen wurden hochgeladen",
  "upload.uploaded_items_with_folders": "1 Element wurde hochgeladen. | {n} von {total} Elementen ({numItems} {items}, {numFolders} {folders}) wurden hochgeladen",
  "upload.uploading_folders": "{folderName} hochgeladen. | {folderName} {uploadingCount} von {n} hochgeladen.",
  "upload.uploading_items": "1 Element wird hochgeladen. | {n} von {total} Elementen werden hochgeladen.",
  "upload.uploading_items_with_folders": "1 Element wird hochgeladen. | {n} von {total} Elementen ({numItems} {items}, {numFolders} {folders}) werden hochgeladen",
  "upload_qr_code.duration.10_minutes": "10 Minuten",
  "upload_qr_code.duration.1_day": "1 Tag",
  "upload_qr_code.duration.1_hour": "1 Stunde",
  "upload_qr_code.duration.30_minutes": "30 Minuten",
  "upload_qr_code.duration.5_minutes": "5 Minuten",
  "upload_qr_code.duration.custom": "Benutzerdefiniert",
  "upload_qr_code.title": "Zum Hochladen nach {location} scannen",
  "upload_qr_code.valid_for": "Gültig für",
  "watches.notifications": "Benachrichtigung",
  "watches.stop.disable.text": "Möchten Sie die Benachrichtigungen für {location} deaktivieren?\nSie erhalten dann keine E-Mails mehr, wenn neue Dokumente hinzugefügt werden.",
  "watches.stop.disable.title": "Benachrichtigung deaktivieren?",
  "watches.stop.disabled.text": "Die Benachrichtigungen für {location} wurden deaktiviert.",
  "watches.stop.disabled.title": "Benachrichtigung deaktiviert",
  "watches.toast.error.error_on_remove_watch": "Fehler beim Entfernen der Beobachtung",
  "watches.toast.error.error_on_start_watch": "Fehler beim Starten der Beobachtung",
  "watches.tooltip": "Benachrichtigung bei neuen Dokumenten in diesem Ordner"
}
